<template>
<div>

<dialogBoxModal  v-if="dialogBox.show" @close="closeDialogBoxModal()" v-bind:props="dialogBox" ></dialogBoxModal>    
<waitingBoxModal v-if="waitModal.show" @close="closeWaitingModal()"  v-bind:props="waitModal" ></waitingBoxModal>
<EpsonFiscalReceiptDeposit v-bind:saleId="saleId" v-bind:balancePaymentSaleId="paymentSaleId" v-if="fiscalPrinter.show==1" @close="fiscalPrinter.show = 0"></EpsonFiscalReceiptDeposit>

<div class="_modal-content_ border border-primary">
    <div class="modal-header bg-primary border-warning">
        <h4 class="card-title text-white">
          
          <i style ="color:white" class="fas fa-money-check mr-3" aria-hidden="true"></i>
          PAGAMENTO</h4>
        
       
      </div>

  <div class="card text-center">
  <div class="card-body">
   
    <h4 class="saleTotal">TOTALE VENDITA {{ fmt1(saleTotal) }}</h4>
    <h4 class="salePaid">PAGATO {{ fmt1(salePaid) }}</h4>
    <h4 class="saleNotPaid">DA SALDARE {{ fmt1(saleNotPaid) }}</h4>
    <div class="row">
    <div class="col-md-6">
      <div class="card-body"></div>

    
    <!-- CASH -->
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-prepend">  
        <div style="background-color:#339900;color:white;width:150px" class="input-group-text"><strong>CONTANTE</strong>  </div>        
          <div class="input-group-text">€</div>        
        </div>
        <input :disabled="CouponIdentification" step="0.01"  type="number" :style="{fontSize: '30px'}" class="form-control" id="inputCash" placeholder="Contante" v-model="cash">
      </div>
    </div>

    <!-- ELEC -->
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-prepend">          
          <div style="background-color:#FF6600;color:black;width:150px" class="input-group-text"><strong>ELETTRONICO</strong></div>  
          <span class="input-group-text"> €</span>       
        
        </div>
        <input :disabled="CouponIdentification" step="0.01" type="number" :style="{fontSize: '30px'}" class="form-control" id="inputElettronico" placeholder="Elettronico" v-model = "electronic">       
      </div>
    </div>

  <!-- COUP -->
    <div class="form-group">

      <div v-if="!CouponIdentification" class="input-group">

        <div class="input-group-prepend">  
          <div style="background-color:navy;color:white;width:150px" class="input-group-text"><strong>COUPON</strong></div>  
          <span class="input-group-text"> €</span>              
        </div>
          <input step="0.01" type="number" :style="{fontSize: '30px'}" class="form-control" id="inputCoupon" placeholder="Coupon" v-model = "coupon">        

          <button v-if="1==1"  @click="CouponIdentification = !CouponIdentification" class="btn btn-primary float-left"
            data-toggle="modal" title="Identificazione coupon"  >
            <i  class="fas fa-search-dollar" aria-hidden="true"></i>
          </button>      
      </div>
      </div>
      <h4 v-if="rest>0" class="rest">RESTO {{ fmt1(rest) }}</h4> 
      <div v-if="CouponIdentification" >
        
        <CouponIdentificationList @close="setCouponIdentification" ></CouponIdentificationList>
        
      </div>


    <OtherPayment v-bind:disabled="CouponIdentification" @update="setOtherPayment"></OtherPayment>  
    
    </div>
    </div>
    
    <button v-if="paymentSaleId==0" :disabled="bt_spinner || CouponIdentification " @click="checkOut()"  class="btn btn-primary btn-lg float-right mt-2 mr-2">
  <i  class="fas fa-check-circle mr-2" aria-hidden="true"></i>
  ESEGUI PAGAMENTO
  <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
</button>

  </div>

  

  </div>


<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>




</div>
</div>




</template>

<script>

import axios                      from 'axios'
import api                        from '@/api'
import { mapGetters }             from 'vuex';
import alertBox                   from '@/components/common/AlertBox.vue'
import OtherPayment               from "@/components/frontOffice/checkOut/OtherPayment.vue"
import CouponIdentificationList   from "@/components/frontOffice/coupon/CouponIdentificationList.vue"
import fmt                        from '@/components/mixins/fmt'
import EpsonFiscalReceiptDeposit  from '@/components/rt/EpsonFiscalReceiptDepositDeduction.vue'
import getSaleData                from '@/components/rt/mixins/getSaleData'
import waitingBoxModal            from "@/components/common/WaitingModal.vue"
import dialogBoxModal             from '@/components/frontOffice/cart/dialogBoxModal.vue'
import selfCash                   from '@/components/mixins/SelfCash.js'


export default {

mixins     : [fmt,getSaleData,selfCash],
props : ['customerId','saleId'], 

components: { alertBox, OtherPayment, CouponIdentificationList, CouponIdentificationList,EpsonFiscalReceiptDeposit,waitingBoxModal,dialogBoxModal },
  data () {
    return {
      
      rest         : 0,
      paymentSaleId    :  0,
      deskId       : 1,  
      cash         : 0,
      electronic   : 0,
      coupon       : 0,           
      payment      : [],
      printReceipt : 0,
      //alert        : false,
      msg          : {
        title      : '',
        body       : '',
        type       : 0
      },
           
      bt_spinner  : false,
      selfCashApi : '',
      otherPayment    : {
        total : 0.00,
        type : ''
      },
      CouponIdentification : false,
      barcode : '',
      coupons : [],
      fiscalPrinter : {},
      items   : [],
      payments : [],
      saleTotal : 0,
      salePaid  : 0,
      saleNotPaid : 0,
      waitModal       : 
      {
        sentinel      : 0,
        show          : false,
        msg1          : '',
        msg2          : '' 
      },
      dialogBox       : {
        show          : false,
        msg           : ''
      },

      

    }
  },
  directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
  computed: 
  {
   ...mapGetters(['storeId','company']) ,   
      
     
  },
  async mounted() 
  {
    localStorage.setItem('customerPayment', JSON.stringify('NO'));
    let deskId = JSON.parse(localStorage.getItem("deskId"))
    if(deskId)
    {    
      this.deskId = Number(deskId)
    }
    
    
    
  },  
  created()
  {

    //console.log('CUSTOMERID',this.customerId,this.saleId)

    this.cash         = this.cash.toFixed(2)      
    this.electronic   = this.electronic.toFixed(2) 
    this.coupon       = this.coupon.toFixed(2)   
    this.otherPayment.total = this.otherPayment.total.toFixed(2)     
    this.getDataSale()


   
    
  },
  methods: 

  {
   
    getDataSale()
      { 
        
        
        //this.bt_spinner = true
        const data     = this.getSaleData(this.saleId)
        data.then((res) => { 
            console.log('SALE DATA ',res);
            this.items     = res[0]
            this.payments  = res[1]
            this.saleTotal = this.items[0].total - this.items[0].total_discount
            this.payments.forEach(item =>{
                if(item.typeId == 'CASH')
                {
                    this.salePaid  += item.amount
                }
                if(item.typeId == 'ELEC')
                {
                    this.salePaid  += item.amount
                }
                if(item.typeId == 'CRED')
                {
                    this.saleNotPaid  += item.amount
                }
            })
            
            this.cash         = this.saleNotPaid
           //this.saleTotal    = this.fmt1(this.saleTotal)
            //this.salePaid     = this.fmt1(this.salePaid)
            //this.saleNotPaid  = this.fmt1(this.saleNotPaid)

          }).catch((err) => { 
            this.items     = []
            this.payments  = []
            console.log(err);
            });
      },
    setCouponIdentification(couponList)
    {
      this.CouponIdentification = !this.CouponIdentification
      couponList.forEach(item =>{
        this.coupon = Number(this.coupon) +  Number(item.total)
      })
      this.coupons = couponList
      
      
    },
  
    setOtherPayment(total,type)
    {

      this.otherPayment.total = total      
      this.otherPayment.type = type
      
      /* FORSE LO DEVO TOGLIERE */
      if(total)
      {
        this.otherPayment.total = total
      

      }
      
    },
   
   
    checkFormat()
    {
    
      if(!this.cash)
      {
       
        this.msg.title = ' - ATTENZIONE - '
        this.msg.body  = 'Formato importo CONTANTE non corretto.'
        this.msg.type  = 1
        return false
      }
            
      if(!this.electronic)
      {
       
        this.msg.title = ' - ATTENZIONE - '
        this.msg.body  = 'Formato importo ELETTRONICO non corretto.'
        this.msg.type  = 1
        return false
      }

      if(!this.coupon)
      {
       
        this.msg.title = ' - ATTENZIONE - '
        this.msg.body  = 'Formato importo COUPON non corretto.'
        this.msg.type  = 1
        return false
      }
      if(!this.otherPayment.total)
      {
      
        this.msg.title = ' - ATTENZIONE - '
        this.msg.body  = 'Formato importo ' + this.otherPayment.type + ' non corretto. Inserire un valore uguale o maggiore di zero.'
        this.msg.type  = 1
        return false
      }
      
    },

    async checkOut()
    {
      localStorage.setItem('customerPayment', JSON.stringify('NO'));
      
      this.msg.title = ''
      if(this.checkFormat() == false)
      {
        return
      }
      if(this.cash == 0 && this.electronic == 0 && this.coupon == 0 && this.otherPayment.total == 0)
      {
       
        this.msg.title = ' - ATTENZIONE - '
        this.msg.body  = 'Importo pagamento non valido'
        this.msg.type  = 1
          return
      }
      if(this.cash > 100000 || this.electronic > 100000 || this.coupon > 100000 || this.otherPayment.total > 10000) 
      {
       
        this.msg.title = ' - ATTENZIONE - '
        this.msg.body  = 'Importo pagamento non valido'
        this.msg.type  = 1
          return
      }    
    
     
     
      this.msg.title = ''
      this.bt_spinner = true
      
      const data     = {}
            
      data.header  = {}
      data.payment = {}

      data.header.companyId     = this.company.Id
      data.header.storeId       = this.storeId
      data.header.deskId        = this.deskId
      data.header.total         = 0
      data.header.discount      = 0
      
      data.header.customerId    = this.customerId
      data.header.printTicket   = 0
     
      data.payment              = this.dataPayment()
      data.coupons              = this.coupons
    
      const sp    = {'sp':'spCreateCustomerPayment'}
      

      const json  = Object.assign(data, sp);

     this.waitModal.msg1    = 'PAGAMENTO IN CORSO ...'
     this.waitModal.show    = true

      await api.post(json).then(res => {
      if(res.status==200)
        {
                    
          this.waitModal.sentinel = 1
          /* SHOW FISCAL PRINTER */
          if(res.data.recordsets[0].length > 0)
          {
            
            
            /* SELF CASH */            
            if(Number(this.cash) > 0)
            {
            
              const cash = Number(this.cash)  
              const total = this.fmt1(cash).replace(',','')            
              
              this.sendTotalToSelfCash(total)
              
            
            
            }



            localStorage.setItem('customerPayment', JSON.stringify('YES'));
            
            this.paymentSaleId = res.data.recordsets[0][0].result
            this.msg.type = 0
            this.msg.title = 'PAGAMENTO ESEGUITO.'

            this.$nextTick(()  => {              
              this.fiscalPrinter.show = 1
               
          })    

            
            
            
          }

          
          
        }
        else if(res.status==500)
        {
          
            this.waitModal.sentinel = 1
            this.dialogBox.show     = true
            this.dialogBox.title    = 'PAGAMENTO'
            this.dialogBox.msg      = res.data  

          
        } 
        else
        {

            this.waitModal.sentinel = 1
            this.dialogBox.show     = true
            this.dialogBox.title    = 'PAGAMENTO'
            this.dialogBox.msg      = res
            
          
        } 
        }).catch(err => 
        {

            this.waitModal.sentinel = 1
            this.dialogBox.title    = 'PAGAMENTO'
            this.dialogBox.show     = true
            this.dialogBox.msg      = err  

          
      
        }).finally(() => {
          this.bt_spinner = false
        });

      

       
      
    },
    closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },
    closeDialogBoxModal()
    {
      
      this.dialogBox.show = false
    },
    dataPayment()
    {
      this.rest = 0
      const arr = []
      
      if(Number(this.cash) != 0)
      {
        
        const cash = Number(this.cash).toFixed(2)   
        if(cash > this.saleNotPaid)     
        {
          this.rest = cash - this.saleNotPaid  
        }
        
        
        const total = cash - this.rest

        

        arr.push({'typeId':'CASH','amount' : Number(total).toFixed(2)  })
        
        //arr.push({'typeId':'CASH','amount' : Number(this.cash).toFixed(2)  })


      }
      
      if(Number(this.electronic) !=0 )
      {
        arr.push({'typeId':'ELEC','amount' : Number(this.electronic).toFixed(2)})
      }

      if(Number(this.coupon)!=0)
      {
        arr.push({'typeId':'COUP','amount' : Number(this.coupon).toFixed(2)})
      }

      if(Number(this.otherPayment.total) != 0)
      {
        
        arr.push({'typeId':this.otherPayment.type,'amount': Number(this.otherPayment.total).toFixed(2)})
      }
     
      return arr
    },

    
 
    

  }
}
</script>
<style scoped>

.rest
{
  color: rgb(3, 45, 21);
  font-size: 30;
  font-weight:bold;
}  
.custom-control-label
{
  cursor : pointer;
  
}
h4,p {
  font-family: 'Roboto Condensed';
  font-size: 25px;
}

.saleTotal
{
    font-size: 30px;
    font-weight:bold;
    color:green
    }
    .saleNotPaid
{
    font-size: 30px;
    font-weight:bold;
    color:red
    } 
    .salePaid
{
    font-size: 30px;
    font-weight:bold;
    color:black
    } 

</style>